/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Decks_View_DecklistInputs */



/**
* | output |
* | --- |
* | "View decklist" |
*
* @param {Decks_View_DecklistInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const decks_view_decklist = /** @type {((inputs?: Decks_View_DecklistInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Decks_View_DecklistInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Voir la decklist")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ver lista de mazo")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Ver lista de deck")
	if (locale === "it") return /** @type {LocalizedString} */ ("Vedi lista del mazzo")
	return /** @type {LocalizedString} */ ("View decklist")
});